/* istanbul ignore file @preserve */
//
// DO NOT EDIT!
// This file was autogenerated by Eddie.
// Changes may cause incorrect behavior and will be lost when the file is regenerated.
//
// Run `npx eddie update workspace` to regenerate.
//

export const APP_NAME = 'basket-provider-app';
export const PACKAGE_NAME = '@ori/basket-provider-app';
export const TEAM_NAME = 'Checkout';
export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;
export const APP_ROOT_ELEMENT_ID = `basket-provider-root`;